import '../css/site.css';

(() => {
    console.log('Hello from ProtonTitans.com');
})();
